import { useState } from "react";
import { LinkButton, Button } from "@/components/catalyst/button";
import { Heading } from "@/components/catalyst/heading";
import { Text } from "@/components/catalyst/text";
import {
  Alert,
  AlertTitle,
  AlertDescription,
  AlertActions,
} from "@/components/catalyst/alert";
import { BuildingOffice2Icon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { useUser } from "@/lib/Auth/useUser";

export function OnboardingWelcomeScreen() {
  const [showJoinDialog, setShowJoinDialog] = useState(false);
  const user = useUser();

  return (
    <div className="flex w-full items-center justify-center">
      <div className="w-full max-w-xs space-y-4">
        <div className="text-center">
          <Heading>Welcome to Imoova</Heading>
          <Text className="mt-1">
            Get started by creating a new organisation or joining an existing
            one.
          </Text>
        </div>

        <div className="space-y-3">
          <LinkButton to="/onboarding/create-org" className="w-full">
            <BuildingOffice2Icon className="h-5 w-5" />
            Create a new organisation
          </LinkButton>

          <Button
            outline
            className="w-full"
            onClick={() => setShowJoinDialog(true)}
          >
            <EnvelopeIcon className="h-5 w-5" />
            Join an existing organisation
          </Button>
        </div>
      </div>

      <Alert open={showJoinDialog} onClose={setShowJoinDialog}>
        <AlertTitle>Join an existing organisation</AlertTitle>
        <AlertDescription>
          To join an existing organisation, you need to be invited by an
          organisation administrator. Ask them to send an invitation to{" "}
          <strong>{user?.email}</strong> and follow the link provided.
        </AlertDescription>
        <AlertActions>
          <Button onClick={() => setShowJoinDialog(false)}>Got it</Button>
        </AlertActions>
      </Alert>
    </div>
  );
}
